module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/1@2x_53efe9bb570b1f2ca3eeff114593554d.png";